// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"index-module--slider-container--3hoiB","slider":"index-module--slider--1Ja80","inputNumber":"index-module--input-number--VF9rK"};